module.exports = __webpack_public_path__ + "static/media/arrow left.a5e0b40b.svg";